import { SET_RATING_ACTION, SET_FEEDBACK_ACTION, SET_SURVEY_CONTACT_ID_ACTION, SET_CONTACT_CONSENT_ACTION, CLOSE_SURVEY_ACTION, INCREMENT_SURVEY_STEP_ACTION, RESET_SURVEY_ACTION } from './constants';
export const initialFeedbackReducerState = {
  activeStep: 0,
  rating: undefined,
  feedback: '',
  surveyContactId: undefined,
  contactConsent: true
};
export const feedbackReducer = (state, action) => {
  switch (action.type) {
    case SET_RATING_ACTION:
      {
        return Object.assign({}, state, {
          rating: action.payload.rating,
          activeStep: 1
        });
      }
    case SET_FEEDBACK_ACTION:
      {
        return Object.assign({}, state, {
          feedback: action.payload.feedback
        });
      }
    case SET_SURVEY_CONTACT_ID_ACTION:
      {
        return Object.assign({}, state, {
          surveyContactId: action.payload.surveyContactId
        });
      }
    case SET_CONTACT_CONSENT_ACTION:
      {
        return Object.assign({}, state, {
          contactConsent: action.payload.contactConsent
        });
      }
    case CLOSE_SURVEY_ACTION:
      {
        return Object.assign({}, state, {
          activeStep: undefined
        });
      }
    case INCREMENT_SURVEY_STEP_ACTION:
      {
        return Object.assign({}, state, {
          activeStep: state.activeStep === undefined ? undefined : state.activeStep + 1
        });
      }
    case RESET_SURVEY_ACTION:
      {
        return initialFeedbackReducerState;
      }
    default:
      {
        return state;
      }
  }
};
export default feedbackReducer;